import React from 'react';
import FieldLabel from './FieldLabel';

// Fields to exclude from display (metadata fields)
const EXCLUDED_FIELDS = [
  'locale',
  'id',
  '__typename',
  'createdAt',
  'updatedAt',
];

function stripHtml(text) {
  if (!text) return '';
  return text.replace(/<[^>]*>/g, '').trim();
}

export default function TranslationDisplay({ translation, isNew = false }) {
  const locale = translation.locale?.toUpperCase() || '??';

  const borderClass = isNew ? 'border-green-300' : 'border-gray-200';
  const bgClass = isNew ? 'bg-green-50' : 'bg-gray-50';

  // Get all fields from the translation object, excluding metadata
  const fields = Object.entries(translation).filter(
    ([key, value]) =>
      !EXCLUDED_FIELDS.includes(key) &&
      value !== null &&
      value !== undefined &&
      value !== '',
  );

  return (
    <div className={`p-3 ${bgClass} rounded border ${borderClass}`}>
      <div className="flex items-center gap-2 mb-2">
        <span className="px-1.5 py-0.5 text-xs font-medium bg-blue-100 text-blue-700 rounded inline-flex items-center gap-1">
          <i className="fa-regular fa-language" />
          {locale}
        </span>
      </div>

      <div className="space-y-2">
        {fields.map(([fieldName, value]) => {
          const displayValue =
            typeof value === 'string' ? stripHtml(value) : String(value);
          if (!displayValue) return null;

          return (
            <div key={fieldName} className="text-sm">
              <div className="mb-1">
                <FieldLabel name={fieldName} />
              </div>
              <div className="px-2 py-1 rounded text-sm bg-white text-gray-700 border border-gray-100 max-h-64 overflow-y-auto whitespace-pre-wrap break-words">
                {displayValue}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
